import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { City, CityList, State } from '../models/location.model';
import { map } from 'rxjs/operators';
import { ApiResponse } from '../models/response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LocationService {

  private _locationEndpoint = `${environment.apiBaseUrl}/location/v1`;

  constructor(private _http: HttpClient) { }

  getCity(id: string): Observable<City> {
    return this._http
      .get<ApiResponse<any>>(this._locationEndpoint + `/cities/${id}`)
      .pipe(map((res) => res.data));
  }

  getCities(data: any): Observable<CityList> {
    data['isOperational'] ??= true;
    return this._http
      .get<ApiResponse<any>>(this._locationEndpoint + '/cities', { params: data, })
      .pipe(map((res) => res.data));
  }

  getPincode(code: string) {
    return this._http
      .get<ApiResponse<any>>(`${this._locationEndpoint}/pincodes/code/${code}`)
      .pipe(map((res) => res.data));
  }

  getStates(): Observable<State[]> {
    const _faqEndpoint = '../../../assets/data/states.json';
    return this._http.get<State[]>(_faqEndpoint);

  }

}